/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	notificationsGrid: {
		position: 'fixed',
		top: '100px',
		width: '100%',
		zIndex: 9999
	}

});

export default styles;
